import React from 'react';
import Table from '../common/Table';
import { StateDTO } from '../../services/apiClient';

interface StateTableProps {
  data: StateDTO[];
  handleEdit: (row: StateDTO) => void;
  handleDelete: (row: StateDTO) => void;
  isLoading: boolean;
}

const StateTable: React.FC<StateTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        { label: 'Name', key: 'name' },
        { label: 'Code', key: 'code' },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      allowPaging={false}
      isLoading={isLoading}
      noDataMessage="No states added yet"
    />
  );
};

export default StateTable;
